<script setup lang="ts">
import { ref } from 'vue';
import GaiaButton from '../base/GaiaButton.vue';
import GaiaSectionHeader from '../base/GaiaSectionHeader.vue';
import { gaiaFontSize, gaiaNeutral, gaiaTextButtonOverrides } from '../themes/tokens';

const props = defineProps({
  label: {
    type: String,
    default: 'AI summary',
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
});

const open = ref(props.defaultOpen);

const border = gaiaNeutral.borderCard;
const bg = gaiaNeutral.surfaceSoft;
const bodyColor = gaiaNeutral.text;
const bodySize = gaiaFontSize.body;
</script>

<template>
  <!-- Collapsible AI-summary card from the review detail (Kanban mock):
       uppercase label + Hide/Show toggle, body in the default slot. -->
  <n-flex vertical :size="8" class="gaia-summary-card">
    <n-flex align="center" :size="8" :wrap="false">
      <gaia-section-header>{{ props.label }}</gaia-section-header>
      <gaia-button
        text
        size="small"
        :theme-overrides="gaiaTextButtonOverrides.ink"
        :style="{ marginLeft: 'auto' }"
        @click="open = !open"
      >
        {{ open ? 'Hide' : 'Show' }}
      </gaia-button>
    </n-flex>
    <div v-if="open" class="body"><slot /></div>
  </n-flex>
</template>

<style scoped>
.gaia-summary-card {
  border: 1px solid v-bind(border);
  border-radius: 12px;
  background: v-bind(bg);
  padding: 14px 15px;
}

.body {
  font-size: v-bind(bodySize);
  line-height: 1.6;
  color: v-bind(bodyColor);
  text-wrap: pretty;
}
</style>
